document.addEventListener('DOMContentLoaded', function () {
  /* Announcement bar dismiss */
  var bar = document.querySelector('[data-announcement-bar]');
  var closeBtn = document.querySelector('[data-announcement-close]');
  if (bar && closeBtn) {
    if (sessionStorage.getItem('announcementDismissed') === '1') {
      bar.classList.add('is-dismissed');
    }
    closeBtn.addEventListener('click', function () {
      bar.classList.add('is-dismissed');
      sessionStorage.setItem('announcementDismissed', '1');
    });
  }

  /* Quick-add modal */
  (function () {
    var modal = document.querySelector('[data-quick-add-modal]');
    if (!modal) return;

    var els = {
      overlay: modal.querySelector('[data-quick-add-overlay]'),
      close: modal.querySelector('[data-quick-add-close]'),
      image: modal.querySelector('[data-quick-add-image]'),
      dots: modal.querySelector('[data-quick-add-dots]'),
      title: modal.querySelector('[data-quick-add-title]'),
      price: modal.querySelector('[data-quick-add-price]'),
      description: modal.querySelector('[data-quick-add-description]'),
      readMore: modal.querySelector('[data-quick-add-read-more]'),
      colorWrap: modal.querySelector('[data-quick-add-color-option]'),
      colorSelectedLabel: modal.querySelector('[data-quick-add-color-selected]'),
      swatches: modal.querySelector('[data-quick-add-swatches]'),
      sizeWrap: modal.querySelector('[data-quick-add-size-option]'),
      sizeLabel: modal.querySelector('[data-quick-add-size-label]'),
      sizes: modal.querySelector('[data-quick-add-sizes]'),
      note: modal.querySelector('[data-quick-add-note]'),
      submit: modal.querySelector('[data-quick-add-submit]')
    };

    var state = { product: null, colorIndex: -1, sizeIndex: -1, color: null, size: null };

    /* Coerce ANYTHING (string, {name}, {value}, number, null) into a plain string.
       Shopify's JSON shape for options/values has varied across stores/versions,
       so every place that touches an option name or option value goes through
       this instead of assuming a plain string. */
    function safeStr(v) {
      if (typeof v === 'string') return v;
      if (v === null || v === undefined) return '';
      if (typeof v === 'object') return String(v.name || v.value || v.title || '');
      return String(v);
    }

    function formatMoney(cents) {
      var format = window.themeMoneyFormat || '${{amount}}';
      var value = (Number(cents) / 100).toFixed(2);
      var parts = value.split('.');
      var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return format.replace(/\{\{.*?\}\}/, withCommas + '.' + parts[1]);
    }

    function uniqueValues(product, index) {
      var out = [];
      product.variants.forEach(function (v) {
        var val = safeStr(v.options[index]);
        if (out.indexOf(val) === -1) out.push(val);
      });
      return out;
    }

    function findVariant(product) {
      return product.variants.find(function (v) {
        var colorOk = state.colorIndex === -1 || safeStr(v.options[state.colorIndex]) === state.color;
        var sizeOk = state.sizeIndex === -1 || safeStr(v.options[state.sizeIndex]) === state.size;
        return colorOk && sizeOk;
      });
    }

    function refreshSizeAvailability() {
      els.sizes.querySelectorAll('[data-size-value]').forEach(function (btn) {
        var val = btn.getAttribute('data-size-value');
        var match = state.product.variants.find(function (v) {
          var colorOk = state.colorIndex === -1 || safeStr(v.options[state.colorIndex]) === state.color;
          return colorOk && safeStr(v.options[state.sizeIndex]) === val;
        });
        btn.disabled = !match || !match.available;
      });
    }

    function updateSubmitState() {
      var variant = findVariant(state.product);
      var needsColor = state.colorIndex > -1 && !state.color;
      var needsSize = state.sizeIndex > -1 && !state.size;

      if (needsColor || needsSize) {
        els.submit.disabled = true;
        els.note.textContent = '';
        return;
      }
      if (!variant) {
        els.submit.disabled = true;
        els.note.textContent = 'This combination is not available.';
        return;
      }
      els.price.innerHTML = formatMoney(variant.price) +
        (variant.compare_at_price > variant.price ? ' <s>' + formatMoney(variant.compare_at_price) + '</s>' : '');
      if (!variant.available) {
        els.submit.disabled = true;
        els.note.textContent = 'Sold out.';
      } else {
        els.submit.disabled = false;
        els.note.textContent = '';
        els.submit.setAttribute('data-variant-id', variant.id);
        if (variant.featured_image && variant.featured_image.src) els.image.src = variant.featured_image.src;
      }
    }

    function renderColorSwatches(product) {
      if (state.colorIndex === -1) { els.colorWrap.hidden = true; return; }
      els.colorWrap.hidden = false;
      els.swatches.innerHTML = '';
      uniqueValues(product, state.colorIndex).forEach(function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quick-add-modal__swatch';
        btn.style.backgroundColor = value.toLowerCase().replace(/\s+/g, '');
        btn.title = value;
        btn.setAttribute('data-color-value', value);
        btn.addEventListener('click', function () {
          state.color = value;
          els.colorSelectedLabel.textContent = value;
          els.swatches.querySelectorAll('.quick-add-modal__swatch').forEach(function (s) { s.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          if (state.sizeIndex > -1) refreshSizeAvailability();
          updateSubmitState();
        });
        els.swatches.appendChild(btn);
      });
    }

    function renderSizes(product) {
      if (state.sizeIndex === -1) { els.sizeWrap.hidden = true; return; }
      els.sizeWrap.hidden = false;
      els.sizeLabel.textContent = safeStr(product.options[state.sizeIndex]);
      els.sizes.innerHTML = '';
      uniqueValues(product, state.sizeIndex).forEach(function (value) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quick-add-modal__size';
        btn.textContent = value;
        btn.setAttribute('data-size-value', value);
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          state.size = value;
          els.sizes.querySelectorAll('.quick-add-modal__size').forEach(function (s) { s.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          updateSubmitState();
        });
        els.sizes.appendChild(btn);
      });
    }

    function showError(err) {
      console.error('Quick add failed', err);
      els.title.textContent = 'Sorry, something went wrong';
      els.colorWrap.hidden = true;
      els.sizeWrap.hidden = true;
      els.description.innerHTML = '';
      els.readMore.hidden = true;
      els.submit.disabled = true;
      /* Show the actual error message right in the popup so it can be
         screenshotted directly, without needing devtools. */
      els.note.textContent = 'Debug info: ' + (err && err.message ? err.message : String(err));
    }

    function populate(product) {
      state.product = product;
      state.colorIndex = -1;
      state.sizeIndex = -1;
      state.color = null;
      state.size = null;

      var options = (product.options || []).slice();
      var hasRealOptions = !(options.length === 1 && safeStr(options[0]) === 'Title');

      if (hasRealOptions) {
        options.forEach(function (opt, i) {
          var down = safeStr(opt).toLowerCase();
          if (down === 'color' || down === 'colour') state.colorIndex = i;
        });
        options.forEach(function (opt, i) {
          if (i !== state.colorIndex) state.sizeIndex = i;
        });
      }

      els.title.textContent = product.title;
      els.price.textContent = formatMoney(product.variants[0].price);
      els.description.innerHTML = product.description || '';
      els.description.classList.remove('is-expanded');
      els.readMore.hidden = (product.description || '').length < 180;
      els.readMore.textContent = 'Read more';
      els.image.src = product.featured_image || (product.images && product.images[0]) || '';
      els.note.textContent = '';
      els.submit.disabled = true;
      els.submit.removeAttribute('data-variant-id');

      if (hasRealOptions) {
        renderColorSwatches(product);
        renderSizes(product);
      } else {
        els.colorWrap.hidden = true;
        els.sizeWrap.hidden = true;
      }

      if (!hasRealOptions || (state.colorIndex === -1 && state.sizeIndex === -1)) {
        var only = product.variants[0];
        els.submit.disabled = !only.available;
        els.submit.setAttribute('data-variant-id', only.id);
        els.note.textContent = only.available ? '' : 'Sold out.';
        if (only.price) els.price.innerHTML = formatMoney(only.price);
      }
    }

    function open(handle) {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      els.title.textContent = 'Loading...';
      els.price.textContent = '';
      els.description.innerHTML = '';
      els.readMore.hidden = true;
      els.colorWrap.hidden = true;
      els.sizeWrap.hidden = true;
      els.note.textContent = '';
      els.submit.disabled = true;
      els.submit.removeAttribute('data-variant-id');
      els.image.removeAttribute('src');

      fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('Request failed with status ' + r.status);
          return r.text();
        })
        .then(function (text) {
          var product;
          try {
            product = JSON.parse(text);
          } catch (e) {
            throw new Error('Response was not valid JSON (store may be redirecting this request): ' + text.slice(0, 120));
          }
          return product;
        })
        .then(function (product) {
          try {
            populate(product);
          } catch (err) {
            showError(err);
          }
        })
        .catch(showError);
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-quick-add-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        try {
          open(btn.getAttribute('data-product-handle'));
        } catch (err) {
          showError(err);
        }
      });
    });

    els.overlay.addEventListener('click', close);
    els.close.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

    els.readMore.addEventListener('click', function () {
      var expanded = els.description.classList.toggle('is-expanded');
      els.readMore.textContent = expanded ? 'Read less' : 'Read more';
    });

    els.submit.addEventListener('click', function () {
      var variantId = els.submit.getAttribute('data-variant-id');
      if (!variantId) return;
      els.submit.disabled = true;
      els.submit.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (data) { throw new Error(data && data.description || 'Add to cart failed'); });
          els.submit.textContent = 'Added';
          setTimeout(function () {
            els.submit.textContent = 'Add to bag';
            els.submit.disabled = false;
            close();
            if (window.cartDrawer) window.cartDrawer.open();
          }, 500);
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          els.note.textContent = 'Debug info: ' + err.message;
          els.submit.textContent = 'Add to bag';
          els.submit.disabled = false;
        });
    });
  })();


  /* Product card color swatches */
  document.querySelectorAll('.product-card__swatches').forEach(function (row) {
    var first = row.querySelector('.product-card__swatch');
    if (first) first.classList.add('is-selected');
  });
  document.querySelectorAll('.product-card__swatch').forEach(function (swatch) {
    swatch.addEventListener('click', function (e) {
      e.preventDefault();
      var card = swatch.closest('.product-card');
      var mainImg = card && card.querySelector('[data-card-main-image]');
      var newSrc = swatch.getAttribute('data-swatch-image');
      var newSrcset = swatch.getAttribute('data-swatch-srcset');
      if (mainImg && newSrc) {
        mainImg.src = newSrc;
        if (newSrcset) mainImg.srcset = newSrcset;
      }
      card.querySelectorAll('.product-card__swatch').forEach(function (s) { s.classList.remove('is-selected'); });
      swatch.classList.add('is-selected');
      if (swatch.scrollIntoView) {
        swatch.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
    });
  });

  /* Hero rain effect */
  document.querySelectorAll('[data-hero-rain]').forEach(function (rain) {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    var density = parseInt(rain.getAttribute('data-rain-density') || '50', 10);
    var count = Math.round(density * (window.innerWidth < 700 ? 0.6 : 1));

    for (var i = 0; i < count; i++) {
      var drop = document.createElement('span');
      drop.className = 'hero__rain-drop';
      var height = 40 + Math.random() * 70; /* px */
      var duration = 0.7 + Math.random() * 0.9; /* seconds */
      var delay = Math.random() * 2; /* seconds */
      var left = Math.random() * 100; /* % */
      var opacity = 0.3 + Math.random() * 0.5;

      drop.style.left = left + '%';
      drop.style.height = height + 'px';
      drop.style.opacity = opacity;
      drop.style.animationDuration = duration + 's';
      drop.style.animationDelay = '-' + delay + 's';

      rain.appendChild(drop);
    }

    /* Stop the rain after 30 seconds: fade it out, then remove the drops. */
    setTimeout(function () {
      rain.classList.add('is-stopped');
      setTimeout(function () { rain.innerHTML = ''; }, 1000);
    }, 30000);
  });

  /* Slideshow (sliding hero) */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('[data-slideshow-track]');
    var slides = root.querySelectorAll('[data-slideshow-slide]');
    var dots = root.querySelectorAll('[data-slideshow-dot]');
    var prevBtn = root.querySelector('[data-slideshow-prev]');
    var nextBtn = root.querySelector('[data-slideshow-next]');
    if (!track || slides.length < 2) return;

    var index = 0;
    var autoplayMs = parseInt(root.getAttribute('data-autoplay') || '0', 10);
    var timer = null;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (dot, di) { dot.classList.toggle('is-active', di === index); });
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function startAutoplay() {
      if (!autoplayMs) return;
      stopAutoplay();
      timer = setInterval(next, autoplayMs);
    }
    function stopAutoplay() { if (timer) clearInterval(timer); }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot, di) {
      dot.addEventListener('click', function () { goTo(di); startAutoplay(); });
    });

    /* Touch swipe */
    var startX = null;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 40) { diff < 0 ? next() : prev(); startAutoplay(); }
      startX = null;
    });

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);

    goTo(0);
    startAutoplay();
  });

  /* Mobile menu */
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  var overlay = document.querySelector('[data-mobile-menu-overlay]');

  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  function openMenu() {
    if (!menu) return;
    menu.classList.add('is-open');
    overlay.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  if (toggle && menu) {
    toggle.addEventListener('click', function () {
      var isOpen = menu.classList.contains('is-open');
      isOpen ? closeMenu() : openMenu();
    });
    overlay.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* Quantity steppers (main form + sticky bar, kept in sync) */
  (function () {
    var mainInput = document.querySelector('[data-qty-input]');
    var stickyInput = document.querySelector('[data-sticky-qty-input]');

    function clampQty(val) {
      var n = parseInt(val, 10);
      if (isNaN(n) || n < 1) n = 1;
      return n;
    }

    function wireStepper(input, decreaseSelector, increaseSelector, onChange) {
      if (!input) return;
      var decrease = document.querySelector(decreaseSelector);
      var increase = document.querySelector(increaseSelector);
      if (decrease) decrease.addEventListener('click', function () {
        input.value = clampQty(input.value) - 1 || 1;
        onChange(input.value);
      });
      if (increase) increase.addEventListener('click', function () {
        input.value = clampQty(input.value) + 1;
        onChange(input.value);
      });
      input.addEventListener('change', function () {
        input.value = clampQty(input.value);
        onChange(input.value);
      });
    }

    wireStepper(mainInput, '[data-qty-decrease]', '[data-qty-increase]', function (val) {
      if (stickyInput) stickyInput.value = val;
    });
    wireStepper(stickyInput, '[data-sticky-qty-decrease]', '[data-sticky-qty-increase]', function (val) {
      if (mainInput) mainInput.value = val;
    });
  })();

  /* Sticky add-to-cart bar */
  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    var mainBtn = document.querySelector('[data-add-to-cart]');
    if (!bar || !mainBtn) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(mainBtn);
    }

    var stickyBtn = document.querySelector('[data-sticky-add-to-cart]');
    var stickyLabel = document.querySelector('[data-sticky-add-to-cart-label]');
    var stickyQtyInput = document.querySelector('[data-sticky-qty-input]');
    var mainQtyInput = document.querySelector('[data-qty-input]');

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (mainQtyInput && stickyQtyInput) mainQtyInput.value = stickyQtyInput.value;
        if (mainBtn.disabled) return;
        stickyBtn.disabled = true;
        if (stickyLabel) stickyLabel.textContent = 'Adding...';
        mainBtn.click();
        setTimeout(function () {
          stickyBtn.disabled = false;
          if (stickyLabel) stickyLabel.textContent = 'Add to bag';
        }, 900);
      });
    }
  })();

  /* Showcase video progress bar + mute toggle */
  document.querySelectorAll('[data-video-card]').forEach(function (card) {
    var video = card.querySelector('.product__social-proof-video');
    var fill = card.querySelector('[data-video-progress]');
    var muteBtn = card.querySelector('[data-video-mute]');
    if (!video) return;

    if (fill) {
      video.addEventListener('timeupdate', function () {
        if (video.duration) fill.style.width = ((video.currentTime / video.duration) * 100) + '%';
      });
      video.addEventListener('ended', function () { fill.style.width = '0%'; });
    }

    if (muteBtn) {
      var iconMuted = muteBtn.querySelector('[data-icon-muted]');
      var iconUnmuted = muteBtn.querySelector('[data-icon-unmuted]');
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        if (iconMuted) iconMuted.hidden = !video.muted;
        if (iconUnmuted) iconUnmuted.hidden = video.muted;
      });
    }
  });

  /* Product page variant picker */
  (function () {
    var form = document.querySelector('[data-add-to-cart]') && document.querySelector('[data-add-to-cart]').closest('form');
    if (!form) return;
    var variantsScript = form.querySelector('[data-product-variants]');
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addLabel = form.querySelector('[data-add-to-cart-label]');
    if (!variantsScript || !idInput) return;

    var variants = JSON.parse(variantsScript.textContent);

    function formatMoney(cents) {
      var format = window.themeMoneyFormat || '${{amount}}';
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return format.replace(/\{\{.*?\}\}/, withCommas + '.' + parts[1]);
    }

    function getSelections() {
      var selections = {};
      form.querySelectorAll('[data-option-input]:checked').forEach(function (input) {
        var position = parseInt(input.name.split('-')[1], 10);
        selections[position] = input.value;
      });
      return selections;
    }

    function findVariant(selections) {
      return variants.find(function (v) {
        return (!selections[1] || v.option1 === selections[1]) &&
               (!selections[2] || v.option2 === selections[2]) &&
               (!selections[3] || v.option3 === selections[3]);
      });
    }

    function updateForVariant(variant) {
      var stickyPriceEl = document.querySelector('[data-sticky-atc-price]');
      var stickyBtn = document.querySelector('[data-sticky-add-to-cart]');
      var stickyImg = document.querySelector('[data-sticky-atc-image]');

      if (!variant) {
        idInput.value = '';
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      idInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = formatMoney(variant.price) +
          (variant.compare_at_price > variant.price
            ? ' <s class="product__price-compare">' + formatMoney(variant.compare_at_price) + '</s>'
            : '');
      }
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);
      addBtn.disabled = !variant.available;
      if (stickyBtn) stickyBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
      if (variant.featured_image && variant.featured_image.src) {
        var mainImg = document.getElementById('ProductMainImage');
        if (mainImg) mainImg.src = variant.featured_image.src;
        if (stickyImg) stickyImg.src = variant.featured_image.src;
      }
    }

    function refreshOptionAvailability() {
      var selections = getSelections();
      form.querySelectorAll('.product__option').forEach(function (fieldset) {
        var radios = fieldset.querySelectorAll('[data-option-input]');
        if (!radios.length) return;
        var position = parseInt(radios[0].name.split('-')[1], 10);
        var isColorFieldset = fieldset.classList.contains('product__option--color');

        radios.forEach(function (input) {
          var candidate = {};
          if (isColorFieldset) {
            /* Colors show as available if ANY size is in stock for them,
               regardless of which size happens to be selected. */
            candidate[position] = input.value;
          } else {
            /* Sizes (and other options) are still constrained by the
               currently selected color. */
            candidate = Object.assign({}, selections);
            candidate[position] = input.value;
          }
          var hasAvailableMatch = variants.some(function (v) {
            return (!candidate[1] || v.option1 === candidate[1]) &&
                   (!candidate[2] || v.option2 === candidate[2]) &&
                   (!candidate[3] || v.option3 === candidate[3]) &&
                   v.available;
          });
          var unavailable = !hasAvailableMatch;
          input.disabled = unavailable;
          var label = input.closest('.option-swatch');
          if (label) label.classList.toggle('is-unavailable', unavailable);
        });
      });
    }

    form.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateForVariant(findVariant(getSelections()));
        refreshOptionAvailability();

        /* If this option is the color picker, update the "OPTION — Value" label live */
        var fieldset = input.closest('.product__option--color');
        if (fieldset) {
          var label = fieldset.querySelector('[data-selected-color]');
          if (label) label.textContent = input.value;
        }
      });
    });

    /* Set initial state to match the pre-selected radios */
    updateForVariant(findVariant(getSelections()));
    refreshOptionAvailability();
  })();

  /* Product thumbnail swap */
  document.querySelectorAll('.product__thumbnail').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.getElementById('ProductMainImage');
      var thumbImg = thumb.querySelector('img');
      if (mainImg && thumbImg) {
        mainImg.src = thumbImg.src.replace(/width=\d+/, 'width=1000');
      }
      var group = thumb.closest('.product__thumbnails');
      if (group) group.querySelectorAll('.product__thumbnail').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* Cart drawer */
  (function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var els = {
      overlay: drawer.querySelector('[data-cart-drawer-overlay]'),
      close: drawer.querySelector('[data-cart-drawer-close]'),
      body: drawer.querySelector('[data-cart-drawer-body]'),
      items: drawer.querySelector('[data-cart-drawer-items]'),
      empty: drawer.querySelector('[data-cart-drawer-empty]'),
      footer: drawer.querySelector('[data-cart-drawer-footer]'),
      subtotal: drawer.querySelector('[data-cart-drawer-subtotal]'),
      count: drawer.querySelector('[data-cart-drawer-count]'),
      shippingBar: drawer.querySelector('[data-shipping-bar]'),
      shippingMessage: drawer.querySelector('[data-shipping-message]'),
      shippingFill: drawer.querySelector('[data-shipping-fill]')
    };

    function formatMoney(cents) {
      var format = window.themeMoneyFormat || '${{amount}}';
      var value = (Number(cents) / 100).toFixed(2);
      var parts = value.split('.');
      var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return format.replace(/\{\{.*?\}\}/, withCommas + '.' + parts[1]);
    }

    function updateShippingBar(totalCents) {
      if (!els.shippingBar) return;
      var threshold = parseInt(els.shippingBar.getAttribute('data-threshold'), 10);
      if (!threshold) return;

      var remaining = threshold - totalCents;
      var percent = Math.min(100, Math.max(0, (totalCents / threshold) * 100));
      els.shippingFill.style.width = percent + '%';

      if (remaining <= 0) {
        els.shippingMessage.innerHTML = '<strong>You\u2019ve unlocked free shipping!</strong>';
      } else {
        els.shippingMessage.innerHTML = 'You\u2019re <strong>' + formatMoney(remaining) + '</strong> away from free shipping';
      }
    }

    function renderCart(cart) {
      var countBadge = document.querySelector('[data-cart-count]');
      if (countBadge) countBadge.textContent = cart.item_count;
      els.count.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      els.subtotal.textContent = formatMoney(cart.total_price);
      updateShippingBar(cart.total_price);

      if (cart.item_count === 0) {
        els.empty.hidden = false;
        els.items.innerHTML = '';
        els.footer.style.display = 'none';
        return;
      }
      els.empty.hidden = true;
      els.footer.style.display = '';

      els.items.innerHTML = '';
      cart.items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'cart-drawer__item';
        li.innerHTML =
          '<img class="cart-drawer__item-image" src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '') + '" alt="">' +
          '<div>' +
            '<p class="cart-drawer__item-title">' + item.product_title + '</p>' +
            (item.variant_title ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>' : '') +
            '<p class="cart-drawer__item-price">' + formatMoney(item.final_price) + '</p>' +
            '<div class="cart-drawer__item-qty-row">' +
              '<button type="button" class="cart-drawer__qty-btn" data-qty-decrease>&minus;</button>' +
              '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
              '<button type="button" class="cart-drawer__qty-btn" data-qty-increase>+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="cart-drawer__item-remove" data-remove-item>Remove</button>';

        li.querySelector('[data-qty-increase]').addEventListener('click', function () {
          changeLine(item.key, item.quantity + 1);
        });
        li.querySelector('[data-qty-decrease]').addEventListener('click', function () {
          changeLine(item.key, item.quantity - 1);
        });
        li.querySelector('[data-remove-item]').addEventListener('click', function () {
          changeLine(item.key, 0);
        });

        els.items.appendChild(li);
      });
    }

    function refresh() {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function (err) { console.error('Cart refresh failed', err); });
    }

    function changeLine(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function (err) { console.error('Cart update failed', err); });
    }

    function open() {
      refresh().then(function () {
        drawer.hidden = false;
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        document.body.style.overflow = 'hidden';
      });
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 320);
    }

    els.overlay.addEventListener('click', close);
    els.close.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    /* Open the drawer from the header cart icon instead of navigating to /cart */
    var cartLink = document.querySelector('.site-header__icon--cart');
    if (cartLink) {
      cartLink.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    }

    window.cartDrawer = { open: open, close: close, refresh: refresh };
  })();

  /* Add to cart (AJAX) */
  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    var form = btn.closest('form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'Add to cart failed');
          btn.textContent = 'Added';
          if (window.cartDrawer) window.cartDrawer.open();
          setTimeout(function () { btn.textContent = 'Add to bag'; }, 1500);
        })
        .catch(function (err) { console.error('Add to cart failed', err); });
    });
  });
});
